module.exports = __webpack_public_path__ + "static/media/heattread-2.552a92a8.jpg";